import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
// import { environment } from '../../../environments/environment.dev2-eu'
// import { ConfigService } from '../services/config.service'

export class CustomTranslateLoader implements TranslateLoader {
  private translateHost: string;
  private translateUrl: string;
  constructor(private http: HttpClient) {
    // const config = this.configService.getConfig()
    // this.translateHost = config.translate.translateHost
    // this.translateUrl = config.translate.translateUrl
    // this.translateHost = environment.translations.apiHost
    // this.translateUrl = environment.translations.translationPath
  }

  // TODO get from the configs(not env)
  getTranslation(lang: string) {
    return this.http.get(`${this.translateHost}${this.translateUrl}deliverysch/${lang}`);
  }
}
